var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "company box is-flex is-centered",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("h1", { staticClass: "title is-4 has-text-primary" }, [
        _vm._v("\n    Configuración de Compañia\n  ")
      ]),
      _c("div", { staticClass: "column is-6" }, [
        _c(
          "div",
          {
            staticClass: "file is-fullwidth is-centered is-boxed",
            class: {
              "is-success": _vm.haveLogo || _vm.logoPdfFileName,
              "has-name": !_vm.haveLogo
            }
          },
          [
            _c(
              "label",
              { staticClass: "file-container", attrs: { for: "logoPdf" } },
              [
                _c("AppInputFile", {
                  attrs: {
                    id: "logoPdf",
                    accept: "image/*",
                    label: _vm.checkImage,
                    value: _vm.image,
                    loading: _vm.loading,
                    disabled: _vm.loading,
                    title: _vm.titleLogo()
                  },
                  on: { input: _vm.validLogo }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c("div", { staticClass: "columns is-multiline" }, [
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("AppInputRfc", {
              attrs: {
                value: _vm.rfc,
                disabled: _vm.loading || _vm.rfcBlocked,
                "is-loading": _vm.loading,
                readonly: _vm.rfcBlocked,
                required: ""
              },
              on: { input: _vm.onChangeRfc, change: _vm.onChangeRfc }
            })
          ],
          1
        ),
        _c("div", { staticClass: "column is-6" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label", attrs: { for: "name" } }, [
              _vm._v("\n          Razón Social:\n        ")
            ]),
            _c(
              "div",
              {
                staticClass: "control has-icons-left",
                class: {
                  "has-icons-right": _vm.isValid.name,
                  "is-loading": _vm.loading
                }
              },
              [
                _c("input", {
                  ref: "name",
                  staticClass: "input",
                  attrs: {
                    id: "name",
                    name: "name",
                    maxlength: "254",
                    placeholder: "Machete SA de CV",
                    disabled: _vm.loading,
                    required: ""
                  },
                  domProps: { value: _vm.name },
                  on: {
                    input: _vm.onChangeCompany,
                    change: _vm.onChangeCompany
                  }
                }),
                _c("BIcon", {
                  staticClass: "is-unselectable is-left",
                  attrs: { icon: "label", size: "is-small" }
                }),
                _vm.isValid.name
                  ? _c("BIcon", {
                      staticClass: "is-unselectable is-right has-text-success",
                      attrs: { icon: "done" }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "column is-6" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label", attrs: { for: "tradeName" } }, [
              _vm._v("\n          Nombre Comercial:\n        ")
            ]),
            _c(
              "div",
              {
                staticClass: "control has-icons-left",
                class: {
                  "has-icons-right": _vm.isValid.tradeName,
                  "is-loading": _vm.loading
                }
              },
              [
                _c("input", {
                  ref: "tradeName",
                  staticClass: "input",
                  attrs: {
                    id: "tradeName",
                    name: "tradeName",
                    maxlength: "254",
                    placeholder: "Machete",
                    disabled: _vm.loading,
                    required: ""
                  },
                  domProps: { value: _vm.tradeName },
                  on: {
                    input: _vm.onChangeCompany,
                    change: _vm.onChangeCompany
                  }
                }),
                _c("BIcon", {
                  staticClass: "is-left is-unselectable",
                  attrs: { icon: "label" }
                }),
                _vm.isValid.tradeName
                  ? _c("BIcon", {
                      staticClass:
                        "is-unselectable is-small is-right has-text-success",
                      attrs: { icon: "check" }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("AppSelectSearch", {
              attrs: {
                id: "regime",
                name: "regime",
                label: "Régimen Fiscal:",
                placeholder: "Selecciona el regimen",
                options: _vm.regimeCatalog,
                value: _vm.regimeValue,
                disable: _vm.loading,
                required: ""
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("AppInputPhoneNumber", {
              attrs: { id: "phoneNumber", value: _vm.phoneNumber },
              on: { input: _vm.onChangePhone, change: _vm.onChangePhone }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("AppInputField", {
              attrs: {
                id: "zipCode",
                name: "zipCode",
                label: "Código Postal:",
                placeholder: "01230",
                value: _vm.zipCode,
                disable: _vm.loading
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            })
          ],
          1
        ),
        _c("div", { staticClass: "column is-12" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label", attrs: { for: "password" } }, [
              _vm._v("\n          Contraseña de Clave Privada\n        ")
            ]),
            _c(
              "div",
              {
                staticClass: "control has-icons-left",
                class: {
                  "has-icons-right": _vm.isValid.password,
                  "is-loading": _vm.loading
                }
              },
              [
                _c("input", {
                  ref: "password",
                  staticClass: "input",
                  attrs: {
                    id: "password",
                    name: "password",
                    type: "password",
                    placeholder: "*******",
                    minlength: "8",
                    maxlength: "50",
                    disabled: _vm.loading
                  },
                  domProps: { value: _vm.password },
                  on: { input: _vm.onChange, change: _vm.onChange }
                }),
                _c("BIcon", {
                  staticClass: "is-left",
                  attrs: { icon: "lock", size: "is-small" }
                }),
                _vm.isValid.password
                  ? _c(
                      "span",
                      { staticClass: "icon is-small is-right" },
                      [
                        _c("BIcon", {
                          staticClass: "is-unselectable has-text-success",
                          attrs: { icon: "check" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "column is-6" }, [
          _c("div", { staticClass: "field" }, [
            _c(
              "div",
              {
                staticClass: "file is-fullwidth is-centered is-boxed",
                class: {
                  "is-success": _vm.haveCer || _vm.cerFileName,
                  "has-name": !_vm.haveCer
                }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "file-label has-text-centered",
                    attrs: { for: "cer" }
                  },
                  [
                    _c("input", {
                      ref: "cer",
                      staticClass: "file-input",
                      attrs: {
                        id: "cer",
                        name: "cer",
                        type: "file",
                        accept: ".cer"
                      },
                      on: { change: _vm.onChangeFile }
                    }),
                    _c("span", { staticClass: "file-cta" }, [
                      _c(
                        "span",
                        { staticClass: "file-icon" },
                        [
                          _c("BIcon", {
                            staticClass: "is-unselectable",
                            attrs: {
                              icon: _vm.cerFileName ? "check" : "cloud-upload"
                            }
                          })
                        ],
                        1
                      ),
                      _c("span", { staticClass: "file-label" }, [
                        _vm._v(
                          "\n                Certificado (.cer)\n              "
                        )
                      ])
                    ]),
                    !_vm.haveCer
                      ? _c(
                          "span",
                          { staticClass: "file-name has-text-centered" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.cerFileName || "Sube el certificado."
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ])
        ]),
        _c("div", { staticClass: "column is-6" }, [
          _c("div", { staticClass: "field" }, [
            _c(
              "div",
              {
                staticClass: "file is-fullwidth is-centered is-boxed",
                class: {
                  "is-success": _vm.haveKey || _vm.keyFileName,
                  "has-name": !_vm.haveKey
                }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "file-label has-text-centered",
                    attrs: { for: "key" }
                  },
                  [
                    _c("input", {
                      ref: "key",
                      staticClass: "file-input",
                      attrs: {
                        id: "key",
                        name: "key",
                        type: "file",
                        accept: ".key"
                      },
                      on: { change: _vm.onChangeFile }
                    }),
                    _c("span", { staticClass: "file-cta" }, [
                      _c(
                        "span",
                        { staticClass: "file-icon" },
                        [
                          _c("BIcon", {
                            staticClass: "is-left",
                            attrs: {
                              size: "is-small",
                              icon: _vm.keyFileName ? "check" : "cloud-upload"
                            }
                          })
                        ],
                        1
                      ),
                      _c("span", { staticClass: "file-label" }, [
                        _vm._v(
                          "\n                Clave privada (.key)\n              "
                        )
                      ])
                    ]),
                    !_vm.haveKey
                      ? _c(
                          "span",
                          { staticClass: "file-name has-text-centered" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.keyFileName || "Sube la llave.") +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ])
        ]),
        ["612", "621"].includes(_vm.regime)
          ? _c("div", { staticClass: "column is-12" }, [
              _c("div", { staticClass: "field" }, [
                _c(
                  "label",
                  { staticClass: "label is-flex", attrs: { for: "curp" } },
                  [
                    _vm._m(0),
                    _c("AppTooltip", {
                      attrs: {
                        label:
                          "Este campo es opcional pero requerido para generar nómina"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "control has-icons-left",
                    class: { "is-loading": _vm.loading }
                  },
                  [
                    _c("input", {
                      ref: "curp",
                      staticClass: "input",
                      attrs: {
                        id: "curp",
                        name: "curp",
                        maxlength: "21",
                        placeholder: "BEML920313HMCLNS09",
                        disabled: _vm.loading,
                        pattern: _vm.curpPattern
                      },
                      domProps: { value: _vm.curp },
                      on: {
                        input: _vm.onChangeCompany,
                        change: _vm.onChangeCompany
                      }
                    }),
                    _c("BIcon", {
                      staticClass: "is-left",
                      attrs: { icon: "label", size: "is-small" }
                    })
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _c("div", { staticClass: "column is-12" }, [
          _c("div", { staticClass: "field" }, [
            _vm._m(1),
            _c(
              "div",
              {
                staticClass: "control has-icons-left",
                class: { "is-loading": _vm.loading }
              },
              [
                _c("input", {
                  ref: "employerRegistration",
                  staticClass: "input",
                  attrs: {
                    id: "employerRegistration",
                    name: "employerRegistration",
                    maxlength: "50",
                    placeholder: "Y68-13217-10-3",
                    disabled: _vm.loading
                  },
                  domProps: { value: _vm.employerRegistration },
                  on: {
                    input: _vm.onChangeCompany,
                    change: _vm.onChangeCompany
                  }
                }),
                _c("BIcon", {
                  staticClass: "is-left",
                  attrs: { icon: "label", size: "is-small" }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "field is-centered" }, [
        _c("div", { staticClass: "control" }, [
          _c(
            "button",
            {
              staticClass: "button is-uppercase is-success",
              class: { "is-loading": _vm.loading },
              attrs: { type: "submit", disabled: _vm.loading }
            },
            [_vm._v("\n        guardar información\n      ")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "help-label" }, [
      _c("div", [_vm._v("CURP")]),
      _c("div", { staticClass: "has-text-gray" }, [
        _vm._v("\n              opcional\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "label is-flex", attrs: { for: "employerRegistration" } },
      [
        _c("div", [
          _c("div", [_vm._v("Registro Patronal")]),
          _c("div", { staticClass: "has-text-gray" }, [
            _vm._v("\n              opcional\n            ")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }